<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="12">
            <v-tabs centered>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-bullhorn</v-icon> Pengumuman
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassworkDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-clipboard-check</v-icon> Tugas
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclasspeopleDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-account-multiple</v-icon> Anggota
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailclassgradeDosen', query: { class: check.class } }"
                exact>
                <v-icon left>mdi-calendar-month</v-icon> Nilai
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="12" v-if="alertdata.show">
            <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
          </v-col>
          <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </v-col>
          <v-col cols="12" md="12" v-if="!loading.detail && detaildata.length > 0">
            <v-card
              flat>
              <v-card-text
                class="black--text">
                <v-btn
                  color="primary"
                  class="text-capitalize mb-5"
                  depressed
                  :loading="loading.downnilai"
                  :disabled="loading.downnilai"
                  @click="downloadNilai">
                  <v-icon left>mdi-download</v-icon>
                  Download
                </v-btn>
                <div class="tblscr-cont">
                  <table class="tblscr-style">
                    <thead>
                      <tr>
                        <th
                          class="text-left text-no-wrap">
                          Mahasiswa
                        </th>
                        <th
                          class="text-left text-no-wrap">
                          Rata-rata
                        </th>
                        <th
                          v-for="(post, i) in datapost"
                          :key="i"
                          class="text-left text-no-wrap">
                          <span
                            class="d-inline-block text-truncate"
                            style="max-width: 150px;"
                            :title="post.title_post">
                            <v-btn
                              v-if="false"
                              icon
                              small
                              color="primary">
                              <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                            {{ post.title_post }}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="nilai in datanilai"
                        :key="nilai.nim">
                        <td
                          class="text-no-wrap">
                          {{ nilai.nim }}<br>
                          ({{ nilai.fname }} {{ nilai.lname }})
                        </td>
                        <td
                          class="text-no-wrap">
                          {{ nilai.avggrade }}
                        </td>
                        <td
                          v-for="(grade, j) in nilai.post"
                          :key="j">
                          <div v-if="grade.idans !== 0">
                            <v-btn
                              icon
                              small
                              color="primary"
                              @click="updateNilai(grade, nilai.fname + ' ' + nilai.lname)">
                              <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                            {{ grade.nilai }}
                          </div>
                          <div v-if="grade.idans === 0">
                            Missing
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="12">
            <div class="mt-5 text-center">
              <v-btn
                class="mr-2 mb-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'ListclassDosen' }">
                <v-icon dark>
                  mdi-arrow-left-thick
                </v-icon>
              </v-btn>
              <span class="title">Daftar kelas</span>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dmodal.upnilai"
      max-width="350px">
      <v-card v-if="dmodaldata.upnilai">
        <v-card-title>
          <span class="headline">Update nilai</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.upnilai = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <v-form
              @submit.prevent="submitUpdateNilai"
              ref="formupdatenilai"
              v-model="formupdate.valid"
              lazy-validation>
              <v-row justify="center">
                <v-col cols="12">
                  <alertsp :alertdata="alertupdate"></alertsp>
                  <v-row>
                    <v-col cols="12" md="12">
                      <div class="font-weight-black">
                        <div class="text-title">
                          {{ dmodaldata.upnilai.title }}
                        </div>
                        <div class="text-subtitle-1">
                          {{ dmodaldata.upnilai.name }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-text-field
                        v-model="dmodaldata.upnilai.nilai"
                        :rules="[rules.required, rules.minnilai]"
                        label="Nilai *"
                        name="grade_answ"
                        type="number">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-btn
                        depressed
                        small
                        color="error"
                        class="mr-1"
                        @click="dmodal.upnilai = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        depressed
                        small
                        :loading="loading.upnilai"
                        :disabled="loading.upnilai || !formupdate.valid"
                        color="success"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'DetailclassgradeDosen',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
      teacher: false,
      student: false,
      remove: false,
      upnilai: false,
      downnilai: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    baseurl: process.env.VUE_APP_BASEURL,
    publickey: '123',
    datanilai: [],
    datastd: [],
    datapost: [],
    detaildata: [],
    teacherlist: [],
    studentlist: [],
    panduan: null,
    paramclass: {
      search: '',
      limit: '',
      offset: '',
    },
    check: {
      class: '',
    },
    formcheck: {
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minnilai: (v) => (!!v && v <= 100) || 'Maksimum nilai 100',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    dmodal: {
      rmhs: false,
      mhs: false,
      upnilai: false,
    },
    dmodaldata: {
      rmhs: null,
      mhs: null,
      upnilai: null,
    },
    msgcopy: '',
  }),
  watch: {
    '$route.query.class'(val) {
      if (val) {
        this.check.class = val;
        this.getMemeber();
      }
    },
  },
  mounted() {
    if (this.$route.query.class && this.$route.query.class !== '') {
      this.check.class = this.$route.query.class;
      this.getMemeber();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    downloadNilai() {
      this.alertdata.show = false;
      if (this.tokenscr) {
        this.loading.downnilai = true;
        this.axios
          .get(
            this.api + '/api/kelas/nilai/download/' + this.check.class,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
              responseType: 'blob',
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'reportnilai-dosen-' + this.detaildata[0].nama_class + '.xls');
              document.body.appendChild(link);
              link.click();
            }
            this.loading.downnilai = false;
          })
          .catch((error) => {
            this.loading.downnilai = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal server error!';
          });
      } else {
        this.alertdata.show = true;
        this.alertdata.type = 'warning';
        this.alertdata.text = 'Invalid token!';
      }
    },
    submitUpdateNilai() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatenilai.validate()) {
        if (this.tokenscr) {
          this.loading.upnilai = true;
          const dataadd = this.dmodaldata.upnilai;
          const datasend = {
            grade_answ: dataadd.nilai,
            answer: dataadd.idans,
            post: dataadd.idpost,
            isgrade: 1,
          };
          this.axios
            .put(
              this.api + '/api/answer/teacher',
              qs.stringify(
                datasend,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Nilai berhasil diupdate!';
                  this.getNilai();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.upnilai = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.upnilai = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    updateNilai(nilai, name) {
      // console.log(nilai);
      nilai.name = name;
      this.dmodal.upnilai = true;
      this.dmodaldata.upnilai = JSON.parse(JSON.stringify(nilai));
      this.alertupdate.show = false;
    },
    getNilai() {
      if (this.tokenscr) {
        this.loading.teacher = true;
        this.axios
          .get(
            this.api + '/api/kelas/nilai/teacher/' + this.check.class,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              this.datanilai = [];
              this.datastd = [];
              this.datapost = [];
              // console.log(resdata);
              if (resdata.error === false) {
                this.datanilai = resdata.data.nilai;
                this.datastd = resdata.data.std;
                this.datapost = resdata.data.post;
              }
            }
            this.loading.teacher = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.teacher = false;
          });
      }
    },
    copyInvitelink() {
      this.msgcopy = '';
      const invelm = document.querySelector('#invite-elm');
      invelm.setAttribute('type', 'text');
      invelm.select();
      try {
        document.execCommand('copy');
        this.msgcopy = 'Copied';
      } catch (err) {
        this.msgcopy = 'Unable to copy!';
      }
      invelm.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
      setTimeout(() => this.msgcopy = '', 7000);
    },
    getMemeber() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.class) {
        this.axios
          .get(
            this.api + '/api/kelas/teacher/' + this.check.class,
            {
              params: this.paramclass,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                const durl = this.$router.resolve({
                  name: 'Invitemahasiswa',
                  params: { class: this.detaildata[0].code_class },
                });
                const baseurl = window.location.origin;
                this.detaildata[0].inviteurl = baseurl + '' + durl.href + '?class=' + this.detaildata[0].code_class;
                this.getNilai();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Anggota tidak ditemukan!';
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
